/* src/app/components/accordion-list/accordion-list.component.scss */
.container {
  width: 100%;
}
.container {
  padding-bottom: 20px;
}
.black-color {
  color: #1A1A18;
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0px;
  background: transparent;
  height: 60px;
}
.header .icon_wrapper ion-icon {
  height: 10px;
  width: 10px;
  rotate: 180deg;
  transition: rotate 0.5s;
  margin-left: 10px;
}
.header .icon_wrapper ion-icon.isOpen {
  rotate: 0deg;
}
.title {
  cursor: pointer;
  position: relative;
  margin: 0;
  font-size: 13px;
  line-height: 16px;
  text-align: left;
  text-transform: capitalize;
  color: #1A1A18;
}
.name {
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.01em;
  color: #1A1A18;
  text-align: left;
  padding: 15px 0px;
}
p {
  padding: 15px 0px;
  text-align: left;
  font-family: AppFont, sans-serif;
  font-size: 11.5px;
  line-height: 20px;
  letter-spacing: 0.01em;
  color: #1A1A18 !important;
}
div {
  position: relative;
  transition: max-height linear 0.3s;
}
div ion-button {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.active {
  max-height: fit-content;
  overflow: hidden;
}
.inactive {
  max-height: 0;
  overflow: hidden;
}
.nutrition-name {
  font-size: 10px;
  text-align: left;
  color: #1A1A18;
  padding-left: 20px;
}
.nutrition-value {
  text-align: right;
  color: #1A1A18;
  font-size: 10px;
  padding-right: 20px;
}
.border-top {
  border-top: 1px solid #dcdddc;
}
.allergens_title {
  font-family: AppFont, sans-serif;
  font-size: 16px;
  color: var(--ion-color-black);
}
ul {
  margin: 0px;
  padding: 0px 30px;
}
ul li {
  font-size: 10px;
  text-align: left;
  color: #1A1A18 !important;
  padding: 6px 0px;
}
.padding-top {
  padding-top: 15px;
}
.final_text {
  padding: 10px 0px;
}
.separator {
  height: 14px;
  width: 100%;
}
/*# sourceMappingURL=accordion-list.component.css.map */
